export default __webpack_public_path__ + "static/media/payment_qr_code_for_thailand.31e99b6a.svg";